import { useEffect, useState } from "react";
import { t } from "../i18n";
import { Lock } from "lucide-react";

const GoogleG = () => (
  <svg width="16" height="16" viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#4285F4" d="M45 24c0-1.6-.1-2.7-.4-4H24v8h12c-.2 2-1.5 5-4.8 7l7.3 5.7C42.8 36.6 45 30.9 45 24z" />
    <path fill="#34A853" d="M24 46c5.9 0 10.9-2 14.5-5.3l-7.3-5.7c-2 1.3-4.5 2.2-7.2 2.2-5.6 0-10.3-3.7-12-8.8l-7.5 5.8C8.1 41.2 15.4 46 24 46z" />
    <path fill="#FBBC05" d="M12 28.4c-.4-1.3-.7-2.7-.7-4.4s.3-3.1.7-4.4l-7.5-5.8C3 16.9 2 20.3 2 24s1 7.1 2.5 10.2l7.5-5.8z" />
    <path fill="#EA4335" d="M24 10.2c3.2 0 6 1.1 8.2 3.2l6.4-6.4C34.9 3.5 29.9 1.5 24 1.5 15.4 1.5 8.1 6.3 4.5 13.8l7.5 5.8c1.7-5.1 6.4-8.8 12-8.8z" />
  </svg>
);

/** Wallet hand-off: the sheet opens on the gateway's secure page, which is where the card lives. */
export const ExpressPay = ({ locale, gateway, ready, busy, onPay, onNeedInfo }) => {
  const [wallet, setWallet] = useState(null);

  useEffect(() => {
    try {
      if (window.ApplePaySession?.canMakePayments?.()) setWallet("apple");
      else if (window.PaymentRequest) setWallet("google");
    } catch {
      setWallet(null);
    }
  }, []);

  if (!wallet) return null;
  const label = wallet === "apple" ? "Apple Pay" : "Google Pay";
  const needInfo = !ready;

  return (
    <div className="space-y-3 mb-10" data-testid="express-pay">
      <p className="smallcaps">{t(locale, "expressTitle")}</p>
      <button
        type="button"
        data-testid={`express-${wallet}`}
        aria-disabled={busy}
        disabled={busy}
        onClick={() => (ready ? onPay() : onNeedInfo())}
        className={`w-full h-[46px] rounded-sm flex items-center justify-center gap-2 text-sm transition-transform hover:-translate-y-px active:translate-y-0 ${
          wallet === "apple" ? "apple-pay-button bg-black text-white" : "bg-black text-white"} ${needInfo ? "opacity-90" : ""}`}
      >
        {wallet === "google" ? <GoogleG /> : null}
        <span className={wallet === "apple" ? "sr-only" : ""}>{label}</span>
        {needInfo ? (
          <span className="ms-2 inline-flex items-center gap-1 rounded-full bg-white/15 px-2 py-0.5 text-[10px] uppercase tracking-wider">
            <Lock size={10} />
            {t(locale, "expressLockedLabel")}
          </span>
        ) : null}
      </button>
      <p className="text-xs text-muted" data-testid="express-note">
        {needInfo
          ? t(locale, "expressLockedNote")
          : t(locale, "expressNote").replace("{wallet}", label).replace("{gateway}", gateway)}
      </p>
      <div className="flex items-center gap-3 pt-2">
        <span className="h-px flex-1 bg-brass-light" />
        <span className="text-xs text-muted">{t(locale, "expressOr")}</span>
        <span className="h-px flex-1 bg-brass-light" />
      </div>
    </div>
  );
};

export default ExpressPay;
